import ArrowForward from "@mui/icons-material/ArrowForward";
import { Box, Divider, Link, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type * as React from "react";
import { COLORS } from "components/v3/Theme/colors";
import {
  GENOMIC_LIFE_PUBLIC_PRIVACY_POLICY_URL,
  GENOMIC_LIFE_PUBLIC_TERMS_OF_USE_URL
} from "constants/externalPathConstants";
import {
  GENOMIC_LIFE_COMPLETE_MEMBER_FEATURES,
  GENOMIC_LIFE_COMPLETE_MEMBER_INTRO,
  GENOMIC_LIFE_COMPLETE_PAID_INVITEE_PLAN_TERMS
} from "constants/genomicLifeCompleteProgramCopy";

const PaidInviteeCompleteSummaryCard: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: COLORS.LIGHT_GRAY,
        borderRadius: "16px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        maxWidth: { lg: 360, xs: "100%" },
        p: { lg: 3, xs: 2.5 },
        width: "100%"
      }}
    >
      <Typography component="h2" variant="h6_black" sx={{ m: 0 }}>
        Genomic Life Complete Plan
      </Typography>

      <Typography component="p" variant="body_dark_gray" sx={{ m: 0 }}>
        {GENOMIC_LIFE_COMPLETE_MEMBER_INTRO}
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {GENOMIC_LIFE_COMPLETE_MEMBER_FEATURES.map((feature) => (
          <Box
            key={feature.label}
            sx={{ alignItems: "flex-start", display: "flex", gap: 1.5 }}
          >
            <ArrowForward
              sx={{
                color: COLORS.PRIMARY,
                flexShrink: 0,
                fontSize: 18,
                mt: 0.35
              }}
            />
            <Typography component="p" variant="body_strong_dark_gray" sx={{ m: 0 }}>
              {feature.label.replace(/:$/, "")}
            </Typography>
          </Box>
        ))}
      </Box>

      <Divider sx={{ borderColor: alpha(COLORS.DARK_GRAY, 0.18) }} />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        {GENOMIC_LIFE_COMPLETE_PAID_INVITEE_PLAN_TERMS.map((term) => (
          <Box
            key={term}
            sx={{ alignItems: "flex-start", display: "flex", gap: 1.5 }}
          >
            <ArrowForward
              sx={{
                color: COLORS.DARK_GRAY,
                flexShrink: 0,
                fontSize: 18,
                mt: 0.35
              }}
            />
            <Typography component="p" variant="body_dark_gray" sx={{ m: 0 }}>
              {term}
            </Typography>
          </Box>
        ))}
      </Box>

      <Typography component="p" variant="body_dark_gray" sx={{ m: 0 }}>
        Please see our{" "}
        <Link
          href={GENOMIC_LIFE_PUBLIC_TERMS_OF_USE_URL}
          rel="noopener noreferrer"
          target="_blank"
          underline="always"
          sx={{
            color: COLORS.DARK_GRAY,
            textDecorationColor: COLORS.DARK_GRAY,
            typography: "body_dark_gray"
          }}
        >
          Terms of Use
        </Link>{" "}
        and{" "}
        <Link
          href={GENOMIC_LIFE_PUBLIC_PRIVACY_POLICY_URL}
          rel="noopener noreferrer"
          target="_blank"
          underline="always"
          sx={{
            color: COLORS.DARK_GRAY,
            textDecorationColor: COLORS.DARK_GRAY,
            typography: "body_dark_gray"
          }}
        >
          Privacy Policy
        </Link>{" "}
        for details.
      </Typography>
    </Box>
  );
};

export default PaidInviteeCompleteSummaryCard;
